var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{'on': _vm.isSelected},on:{"click":function($event){$event.stopPropagation();return _vm.action_Select.apply(null, arguments)}}},[_c('span',[_c('button',{staticClass:"ellipsis"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }